import { isEnabled } from '@js/core/cookies/cookiePreferences.js';
import { isLive, baseHostname, isEzekia, exists } from '@js/core/cookies/helpers';

const gaCookies = ['_ga', '_gid', '_gat'];
// Google Analytics
const gaID = isEzekia ? 'G-0T1BY0K7YS' : 'G-1KVVZGQRQT';
// Google Tag tracking id
const gtID = isEzekia ? 'GTM-PVDPJC5' : 'GTM-5PQHKXQ';
const domain = '.' + baseHostname;

function injectGA4() {
    if (exists('ga4Tag')) {
        return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.id = 'ga4Tag';
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaID;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', gaID);
}

function injectGTM() {
    if (exists('gtmTag')) {
        return;
    }
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

        const script = document.createElement('script');
        script.id = 'gtmTag';
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtm.js?id=' + gtID;
        script.onerror = () => {
            // Clean up on failure
            const idx = window.dataLayer.findIndex(e => e && e.event === 'gtm.js');
            if (idx > -1) {
                window.dataLayer.splice(idx, 1);
            }
        };
        document.head.appendChild(script);

        if (!exists('gtmNoScript')) {
            const noscript = document.createElement('noscript');
            noscript.id = 'gtmNoScript';
            noscript.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + gtID + '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
            document.body.appendChild(noscript);
        }
    } catch (e) {
        // Fail silent; GTM optional
    }
}

function setup() {
    if (!isEnabled('analytics')) {
        return;
    }
    try {
        injectGA4();
        if (isLive) {
            injectGTM();
        }
    } catch (error) {
        if (error && error.status === 0) {
            return;
        }
        throw error;
    }
}

function ensureGA() {
    if (isEnabled('analytics') && (typeof window.gtag !== 'function')) {
        setup();
    }
}

function sendPageView(path) {
    if (typeof window.gtag !== 'function') {
        return;
    }
    window.gtag('event', 'page_view', {
        page_path: path || window.location.pathname,
    });
}

function setPage(path, user, extra = null) {
    ensureGA();
    if (!isEnabled('analytics')) {
        return;
    }

    const pageValue = path && typeof path === 'object' ? path.path : path;

    if (user && user.id && typeof window.gtag === 'function') {
        window.gtag('set', { user_id: user.id });
    }

    if (extra && typeof window.gtag === 'function') {
        window.gtag('event', extra.event || 'custom_event', extra.params || {});
    }

    sendPageView(pageValue);
}

function optOut() {
    window['ga-disable-' + gaID] = true;
    removeCookies();
    removeScripts();
}

function optIn() {
    if (!isEnabled('analytics')) {
        return;
    }
    window['ga-disable-' + gaID] = false;
    setup();
}

function removeCookies() {
    if (typeof _ !== 'undefined' && typeof Cookie !== 'undefined') {
        gaCookies.forEach(key => {
            Cookie.remove(key, { path: '/', domain });
        });
    }
}

function removeScripts() {
    ['ga4Tag', 'gtmTag', 'gtmNoScript'].forEach(id => {
        const el = document.getElementById(id);
        if (el) {
            el.remove();
        }
    });
}

const Analytics = {
    setup,
    setPage,
    optOut,
    optIn,
};

export default Analytics;
